import { Page } from '../../app/page-url-path';
import { convertDotcmsEnumValues } from './converters-from-dotcms';
import type { ICategoryData } from './dotcms-category';
import { getActiveCategories } from './dotcms-category';

/** THE STRING VALUES IN HERE MUST MATCH WHAT IS IN DOTCMS!!!
 */
export enum PageSet {
  ALL_PAGES = 'ALL_PAGES',
  ALL_PAGES_EXCEPT_ENROLLMENT = 'ALL_PAGES_EXCEPT_ENROLLMENT',
  ALL_PAGES_EXCEPT_ENROLLMENT_AND_ACCOUNT = 'ALL_PAGES_EXCEPT_ENROLLMENT_AND_ACCOUNT',
}

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const allPages = Object.keys(Page).map((x) => Page[x as keyof typeof Page]);

const PageSetPages: Readonly<{ [key in PageSet]: () => Page[] }> = {
  [PageSet.ALL_PAGES]: () => allPages,
  [PageSet.ALL_PAGES_EXCEPT_ENROLLMENT]: () =>
    allPages.filter((x) => ![Page.ENROLLMENT_PAGE].includes(x)),
  [PageSet.ALL_PAGES_EXCEPT_ENROLLMENT_AND_ACCOUNT]: () =>
    allPages.filter(
      (x) =>
        ![
          Page.ENROLLMENT_PAGE,
          Page.ACCOUNT_PAGE,
          Page.ACCOUNT_PAGE_CONTACT_INFORMATION,
          Page.ACCOUNT_PAGE_DOCUMENTS,
          Page.ACCOUNT_PAGE_MANAGE_ELECTION,
          Page.ACCOUNT_PAGE_PURCHASE_DETAILS,
          Page.ACCOUNT_PAGE_STATUS_SUMMARY,
          Page.ACCOUNT_PAGE_STOCK_INFORMATION,
          Page.AUTO_SALE_BROKER_QUESTIONS,
        ].includes(x),
    ),
};

export const getDisplayOnPages = (
  cmsResponse:
  | ReadonlyArray<Omit<ICategoryData, 'identifier' | 'contentType'>>
  | null
  | undefined
  | '',
): Page[] => {
  if (!cmsResponse) {
    return [];
  }

  const activeCategoriesInResponse = getActiveCategories(cmsResponse);
  const displayOnIndividualPages =
    convertDotcmsEnumValues(Page, activeCategoriesInResponse) ?? [];
  const displayOnPagesSet = convertDotcmsEnumValues(
    PageSet,
    activeCategoriesInResponse,
  );
  let displayOnPagesArray = displayOnIndividualPages;
  if (displayOnPagesSet) {
    displayOnPagesSet.forEach((set) => {
      const pages = PageSetPages[set]();
      displayOnPagesArray = displayOnPagesArray.concat(pages);
    });
  }
  const displayOnUniquePages = displayOnPagesArray.filter(
    (value, index, array) => array.indexOf(value) === index,
  );

  return displayOnUniquePages;
};
